<div class="wrap">
  <h1>Réinitialisez votre mot de passe</h1>
  <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
    <mat-form-field class="example-form-field" appearance="outline">
      <mat-label>Votre email</mat-label>
      <input matInput type="text" formControlName="email" (input)="isInactive($event.target.value)">
    </mat-form-field>

    <div class="btn_action"><button [disabled]="loading" type="submit"
        [ngClass]="{inactive: !inactive}">Envoyer</button>
    </div>
  </form>
</div>